import { render, staticRenderFns } from "./CommunicationCard.vue?vue&type=template&id=6030fa36&scoped=true&"
import script from "./CommunicationCard.vue?vue&type=script&lang=js&"
export * from "./CommunicationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6030fa36",
  null
  
)

export default component.exports